import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
class SupplierPaymentDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payment: [],
      banks: [],
      branches: [],
      formData: {
        id: '',
        amount: '',
        branch_id: '',
        customer_id: '',
        collection_date: '',
        payment_type: '',
        description: '',
        bank_id: '',
      },
      loading: false,
      isLoad: true,
    }
  }
  async componentDidMount() {
    this.getPaymentInfo();
    this.getBanks();
    this.setState({
      branches: await getBranches(),
    });
  }
  getBanks = async () => {
    try {
      const response = await apiCall('business/settings/bank-account-list', 'get', null);

      this.setState({ banks: response });
    } catch (e) {
      console.error("API çağrısında bir hata oluştu:", e);
    }
  };
  getPaymentInfo = async () => {
    const { id } = this.props.match.params;
    try {
      const response = await apiCall('business/receivable/supplier/payment-info/' + id, 'get', null);
      this.setState({ payment: response });
      this.recordVersion = response.version;
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        updatedData[key] = response[key] === undefined || response[key] === null ? "" : response[key]
      })
      this.setState({ formData: updatedData, isLoad: false }, () => { });
    } catch (e) {
      this.setState({ isLoad: false });
    }
  }
  handlePaymentChange = (e) => {
    const { id, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value
      }
    }))
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { id } = this.props.match.params;
    const { formData } = this.state;
    const paymentFormData = new FormData();
    paymentFormData.append('_version', this.recordVersion || '');
    Object.keys(formData).forEach(key => {
      paymentFormData.append(key, formData[key]);
    });
    try {
      const response = await apiCall('business/receivable/supplier/update-collection/' + id, 'post', paymentFormData);
      if (response.data?.version) this.recordVersion = response.data.version;
      this.setState({ loading: false });
      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  render() {
    const { formData, loading, banks, branches } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateStatusPermission = userPermissions.includes('update setting service status');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Ödeme Detayları"
              Breadcrumb={[
                { name: "Ödemeler", navigate: "" },
                { name: "Ödeme Detayları", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          <label htmlFor="amount" className="font-weight-bold text-cyan">Tutar</label>
                          <div className="form-group">
                            <input
                              name="amount"
                              id="amount"
                              type="number"
                              className="form-control"
                              placeholder="Tahsilat/Ödeme Tutarı Giriniz"
                              value={this.state.formData.amount}
                              onChange={this.handlePaymentChange}
                            />
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">
                          <label htmlFor="branch_id" className="font-weight-bold text-cyan">Şube</label>
                          <div className="form-group">
                            <select
                              id='branch_id'
                              name='branch_id'
                              className="form-control"
                              value={formData.branch_id}
                              onChange={this.handlePaymentChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches && (branches.map(branch => (
                                <option key={branch.id}
                                  value={branch.id}>{branch.name}</option>
                              )))}
                            </select>
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">
                          <label htmlFor="bank_id" className="font-weight-bold text-cyan">Banka</label>
                          <div className="form-group">
                            <select name="bank_id" id='bank_id' className="form-control"
                              onChange={this.handlePaymentChange}>
                              <option value="">Banka Seçiniz</option>
                              {banks && (banks.map(bank => (
                                <option key={bank.id} value={bank.id}>{bank.name}</option>
                              )))}

                            </select>
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">
                          <label htmlFor="payment_type" className="font-weight-bold text-cyan">Ödeme Türü</label>
                          <div className="form-group">
                            <select
                              name="payment_type"
                              id="payment_type"
                              className="form-control"
                              value={this.state.formData.payment_type}
                              onChange={this.handlePaymentChange}>
                              <option value="">Ödeme Tipi Seçiniz</option>
                              <option value="Nakit">Nakit</option>
                              <option value="Kredi Kartı">Kredi Kartı</option>
                              <option value="Havale/EFT">Havale/EFT</option>
                            </select>
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">
                          <label htmlFor="collection_date" className="font-weight-bold text-cyan">Ödeme Tarihi</label>
                          <div className="form-group">
                            <input
                              name="collection_date"
                              id="collection_date"
                              type="date"
                              className="form-control"
                              value={this.state.formData.collection_date}
                              onChange={this.handlePaymentChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <label htmlFor="description" className="font-weight-bold text-cyan">Detay</label>
                          <div className="form-group">
                            <input
                              name="description"
                              id="description"
                              type="text"
                              className="form-control"
                              value={this.state.formData.description}
                              onChange={this.handlePaymentChange}
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          {loading ? (
                            <button className="btn btn-outline-primary btn-block"
                              disabled={true}
                              style={{ textAlign: "-webkit-center" }}>
                              Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                height={'24px'}
                                color="#268bd2"></ReactLoading>
                            </button>
                          ) :
                            <button disabled={!userHasUpdateStatusPermission}
                              className="btn btn-outline-primary btn-block"
                              type="submit">
                              Güncelle
                            </button>}

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(SupplierPaymentDetail)));
